import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addLeagueNew } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew/leaguesNewQueryKeys";
import { AddLeagueNewParams } from "@/types/ApiResponses/League";

export const useAddLeagueNew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddLeagueNewParams) => addLeagueNew(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [LeaguesNewQueryKeys.LeaguesNew],
      });
    },
  });
};
